import { FC, HTMLProps } from 'react'

import { classNames } from '../../functions'

export interface DotsProps extends HTMLProps<HTMLSpanElement> {}
/**
 * @param {HTMLProps<HTMLSpanElement>}props
 * @return {JSX.Element} Loading Dots . .. ...
 */
export const Dots: FC<DotsProps> = (props,) => {
  return (
    <span
      {...props}
      className={classNames(
        props.className ? props.className : '' ,
        "after:inline-block after:animate-ellipsis after:content-['.'] after:w-[1em]  after:text-left"
      )}
    >
      {props.children}
    </span>
  )
}
